import * as React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from "recharts";
import { CartesianGrid } from "recharts";
import { Tooltip } from "recharts";

const StudentRankingOverview = ({ rankingData }) => {
  // const { myRanking } = useSelector((state) => state.ranking);

  // const rankingData = myRanking.ranking;
  console.log(rankingData, "data ");

  const barChartData = [
    {
      category: "Attendance",
      score: Math.round(rankingData.attendanceScore || 0),
      max: 100,
    },
    {
      category: "Interviews",
      score: Math.round(rankingData.interviewScore || 0),
      max: 100,
    },
    {
      category: "Assignments",
      score: Math.round(rankingData.assignmentScore || 0),
      max: 100,
    },
    {
      category: "Daily Tasks",
      score: Math.round(rankingData.taskScore || 0),
      max: 100,
    },
  ];

  const recentActivities = [
    {
      name: `Assignments: ${rankingData.stats?.assignments.submitted || 0}/${
        rankingData.stats?.assignments.total || 0
      } submitted`,
      score: Math.round(rankingData.stats?.assignments.avgScore || 0),
      date: `${rankingData.stats?.assignments.graded || 0} graded, ${
        rankingData.stats?.assignments.missed || 0
      } missed`,
      type: "assignment",
    },
    {
      name: `Tasks: ${rankingData.stats?.tasks.submitted || 0}/${
        rankingData.stats?.tasks.total || 0
      } completed`,
      score: Math.round(rankingData.stats?.tasks.avgScore || 0),
      date: `${rankingData.stats?.tasks.graded || 0} graded`,
      type: "task",
    },
    {
      name: `Interviews: ${rankingData.stats?.interviews.completed || 0}/${
        rankingData.stats?.interviews.total || 0
      } completed`,
      score: Math.round(rankingData.stats?.interviews.avgScore || 0),
      date: `${rankingData.stats?.interviews.missed || 0} missed`,
      type: "interview",
    },
    {
      name: `Attendance: ${rankingData.stats?.attendance.present || 0}/${
        rankingData.stats?.attendance.total || 0
      } days`,
      score: Math.round(rankingData.stats?.attendance.percentage || 0),
      date: `${rankingData.stats?.attendance.percentage || 0}% present`,
      type: "attendance",
    },
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 shadow-sm gap-6">
      {/* Category Breakdown */}
      <Card className="lg:col-span-2 shadow-md bg-white border-0">
        <CardHeader className="border-b border-gray-100">
          <CardTitle className="text-lg font-semibold text-foreground">
            Category Breakdown
          </CardTitle>
        </CardHeader>
        <CardContent className="pt-6 transition-colors duration-300">
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={barChartData}>
              <CartesianGrid
                strokeDasharray="3 3"
                className="dark:stroke-gray-700"
                stroke="#f0f0f0"
                vertical={false}
              />
              <XAxis
                dataKey="category"
                tick={{
                  fill: "#6b7280",
                  fontSize: 12,
                }}
                axisLine={{ stroke: "#e5e7eb" }}
                tickLine={{ stroke: "#e5e7eb" }}
                className="dark:[&_*]:fill-gray-400 dark:[&_*]:stroke-gray-600"
              />
              <YAxis
                tick={{
                  fill: "#6b7280",
                  fontSize: 12,
                }}
                axisLine={{ stroke: "#e5e7eb" }}
                tickLine={{ stroke: "#e5e7eb" }}
                className="dark:[&_*]:fill-gray-400 dark:[&_*]:stroke-gray-600"
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: "var(--tooltip-bg, white)",
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
                  color: "var(--tooltip-text, #111827)",
                }}
                wrapperStyle={{
                  "--tooltip-bg": "white",
                  "--tooltip-text": "#111827",
                }}
                cursor={{ fill: "rgba(99, 102, 241, 0.1)" }}
              />
              <Bar
                dataKey="score"
                fill="#6366f1"
                className="dark:[fill:#818cf8]"
                radius={[8, 8, 0, 0]}
                maxBarSize={60}
              />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      {/* Recent Activity */}
      <Card className="bg-white border-0 shadow-md">
        <CardHeader className="border-b border-gray-100">
          <CardTitle className="text-lg font-semibold text-foreground">
            Statistics Overview
          </CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="space-y-4">
            {recentActivities.map((activity, index) => {
              const colors = {
                assignment:
                  "bg-pink-50 text-pink-600 border-pink-100 dark:bg-pink-900/40 dark:text-pink-300 dark:border-pink-800",
                task: "bg-amber-50 text-amber-600 border-amber-100 dark:bg-amber-900/40 dark:text-amber-300 dark:border-amber-800",
                interview:
                  "bg-purple-50 text-purple-600 border-purple-100 dark:bg-purple-900/40 dark:text-purple-300 dark:border-purple-800",
                attendance:
                  "bg-blue-50 text-blue-600 border-blue-100 dark:bg-blue-900/40 dark:text-blue-300 dark:border-blue-800",
              };

              return (
                <div
                  key={index}
                  className="flex items-center justify-between p-3 rounded-lg border border-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                >
                  <div className="flex-1">
                    <div className="font-medium text-foreground text-sm mb-1">
                      {activity.name}
                    </div>
                    <div className="text-xs text-gray-500">{activity.date}</div>
                  </div>
                  <div
                    className={`px-3 py-1 rounded-md border text-sm font-semibold ${
                      colors[activity.type]
                    }`}
                  >
                    {activity.score}%
                  </div>
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default StudentRankingOverview;
